const TOKEN_KEY = 'atlas_auth_token';

/**
 * Decode JWT token without verification
 * Returns null if token is invalid
 */
function decodeJWT(token: string): { exp?: number } | null {
	try {
		const base64Url = token.split('.')[1];
		if (!base64Url) return null;

		const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
		const jsonPayload = decodeURIComponent(
			atob(base64)
				.split('')
				.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
				.join('')
		);

		return JSON.parse(jsonPayload);
	} catch (error) {
		// console.error('Failed to decode JWT:', error);
		return null;
	}
}

/**
 * Check if token is expired
 */
function isTokenExpired(token: string): boolean {
	const decoded = decodeJWT(token);
	if (!decoded || !decoded.exp) {
		return true; // No expiration means invalid token
	}

	// exp is in seconds, Date.now() is in milliseconds
	const expirationTime = decoded.exp * 1000;
	const now = Date.now();

	// Add 60 second buffer to handle clock skew
	return now >= expirationTime - 60000;
}

/**
 * Save JWT token to localStorage
 */
export function saveToken(token: string): void {
	localStorage.setItem(TOKEN_KEY, token);
}

/**
 * Get JWT token from localStorage
 */
export function getToken(): string | null {
	return localStorage.getItem(TOKEN_KEY);
}

/**
 * Remove JWT token from localStorage
 */
export function removeToken(): void {
	localStorage.removeItem(TOKEN_KEY);
}

/**
 * Check if user has a valid, non-expired token
 */
export function hasToken(): boolean {
	const token = getToken();
	if (!token) return false;

	// Check if token is expired
	if (isTokenExpired(token)) {
		// console.log('Token expired, removing...');
		removeToken();
		return false;
	}

	return true;
}
